// extracted by css-extract-rspack-plugin
module.exports =  {"consBox":"ihmsd","consBoxHead":"TjyaZ","conBoxInfoText":"LDAOR","conBoxTitle":"nVrIH","small":"DOt4r"};